import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSystemActions } from 'stores';

interface LoadingProps {
	value?: number;
	content: string;
}

const CircularProgressWithoutLabel = () => {
	return (
		<>
			<Box sx={{ display: 'flex' }}>
				<CircularProgress />
			</Box>
		</>
	);
};

const CircularProgressWithLabel = (value: number) => {
	return (
		<>
			<Box sx={{ position: 'relative', display: 'inline-flex' }}>
				<CircularProgress
					variant="determinate"
					value={value}
					sx={{ color: 'primary.main' }}
				/>
				<Box
					sx={{
						top: 0,
						left: 0,
						bottom: 0,
						right: 0,
						position: 'absolute',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<Typography variant="caption" color="primary.main">
						{Math.round(value)}%
					</Typography>
				</Box>
			</Box>
		</>
	);
};

const Loading = (props: LoadingProps) => {
	const { getImage } = useSystemActions();
	const { value, content } = props;

	return (
		<>
			<Stack
				direction="column"
				spacing={2}
				alignItems="center"
				justifyContent="flex-start"
				p={2}
				sx={{
					position: 'absolute',
					top: 0,
					width: '100%',
					height: '100%',
					backgroundColor: 'background.default',
					backgroundImage:
						process.env.REACT_APP_CUSTOM_TEXTURE &&
						`url(${getImage(
							process.env.REACT_APP_CUSTOM_TEXTURE
						)})`,
					zIndex: (theme) => theme.zIndex.modal + 2,
				}}
			>
				<Box
					component="img"
					sx={{
						width: '95%',
						maxHeight: '30vw',
						objectFit: 'contain',
						marginTop: '35%',
						marginBottom: '25%',
					}}
					alt="AR_Logo"
					src={getImage(process.env.REACT_APP_CUSTOM_LOGO || '')}
				/>
				{value !== undefined
					? CircularProgressWithLabel(value)
					: CircularProgressWithoutLabel()}
				<Box
					sx={{
						paddingTop: '20%',
					}}
				>
					<Typography
						variant="body1"
						color="primary.main"
						align="center"
					>
						{content}
					</Typography>
				</Box>
			</Stack>
		</>
	);
};

export default Loading;
